import React, { useEffect, useState } from 'react'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { Button, DialogActions, makeStyles } from '@material-ui/core'
import { useResErrors } from 'hooks'
import { CarService } from 'lib/api'
import { Modal } from 'asterX-UI/Modals'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { ON_YOU } from 'constants/keyStatuses'
import useModalbar from 'modules/Modalbar/useModalbar'
import { useAuthStore } from 'context/AuthStore'
import CarData from 'components/Desktop/Car/CarData'
import GetKeysModal from 'pages/Desktop/Selection/Manager/components/GetKeys/GetKeysModal'
import CarInspection from 'components/Desktop/Car/CarInspection'
import CarSelectionCard from 'components/Desktop/Car/CarSelectionCard'
import { MANAGER_AUTO_DAMU } from 'constants/roles'

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative'
  },
  buttonBar: {
    display: 'flex',
    position: 'sticky',
    justifyContent: 'space-between',
    width: '100%'
  },
  rootDiv: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    position: 'relative',
    overflowY: 'auto',
    height: '78vh',
    marginTop: 20
  }
}))
const Demonstration = () => {
  const classes = useStyles()
  const {
    store: { selectedCars, demonstratedCars },
    funcs: { goNextStep, sendInspectionResult }
  } = useSelectionStore()
  const { standardCheck } = useResErrors()
  const { callModalbar } = useModalbar()
  const [keysList, setKeysList] = useState([])
  const [activeCar, setActiveCar] = useState(null)
  const [load, setLoad] = useState(false)
  const [openKeys, setOpenKeys] = useState(false)
  const [isInspectionModalOpen, setIsInspectionModalOpen] = useState(false)
  const {
    authStore: { user }
  } = useAuthStore()
  const userBranch = user?.data?.branch?.name
  const userRole = user.role
  useEffect(() => {
    if (selectedCars?.length > 0 && userRole !== MANAGER_AUTO_DAMU) {
      getKeysStatus()
    }
  }, [selectedCars?.length])

  const handleCarClick = car => {
    setActiveCar(car)
  }
  const handleOpenKeys = () => setOpenKeys(p => !p)
  const getKeysStatus = async () => {
    setLoad(true)
    await CarService.checkKeysStatus(selectedCars.map(v => v.vin)).then(r =>
      standardCheck(r, () => {
        setKeysList(r?.data)
      })
    )
    setLoad(false)
  }
  const acceptKeys = async (id, saleId) => {
    setLoad(true)
    await CarService.acceptKey(id, saleId).then(r =>
      standardCheck(r, getKeysStatus)
    )
    setLoad(false)
  }
  const getDemonstrationResults = vin => {
    const car = demonstratedCars?.find(car => car.vin === vin)
    if (car) {
      return {
        resultConfiguration: car?.resultConfiguration,
        resultExternal: car?.resultExternal,
        resultPrice: car?.resultPrice,
        resultTechnical: car?.resultTechnical,
        resultTestDrive: car?.resultTestDrive,
        resultTestDriveExpress: car?.resultTestDriveExpress,
        isNotDemonstrated: car?.isNotDemonstrated,
        comment: car?.comment
      }
    }
    return null
  }
  const checkPrevSave = async () => {
    if (userRole !== MANAGER_AUTO_DAMU) {
      if (demonstratedCars.length === 0) {
        return callModalbar(
          'Выполните одно из условий!',
          <ul>
            <li>Получите ключи и заполните результат осмтора </li>
            <li>
              Если Авто не в вашем филиале выберете авто мобильным осмотром{' '}
            </li>
          </ul>,
          {
            variant: 'warning',
            btnText: 'Понятно'
          }
        )
      }
      const keyTakenForVins = keysList
        ?.filter(k => k?.status === ON_YOU)
        .map(v => v.vin)

      const carsWithoutInspection = selectedCars
        .filter(
          v =>
            keyTakenForVins.includes(v.vin) &&
            !demonstratedCars.find(d => d?.vin === v.vin)
        )
        .map(
          car =>
            `${
              typeof car?.marka === 'string' ? car?.marka : car?.marka?.name
            } ${
              typeof car?.model === 'string' ? car?.model : car?.model?.name
            } ${car?.year}`
        )

      if (carsWithoutInspection.length > 0) {
        return callModalbar(
          'Заполните Результат осмотра для:',
          <ul>
            {carsWithoutInspection.map(v => (
              <li>{v}</li>
            ))}
          </ul>,
          {
            btnText: 'Понятно'
          }
        )
      }
    }
    if (userRole === MANAGER_AUTO_DAMU) {
      await Promise.all(
        selectedCars.map(async (v, i) => {
          if (!getDemonstrationResults(v.vin)) {
            setLoad(true)
            await sendInspectionResult(v, {
              resultPrice: '',
              resultConfiguration: '',
              resultExternal: '',
              resultTechnical: '',
              resultTestDriveExpress: null,
              isNotDemonstrated: true
            })
          }
        })
      )
    }
    return goNextStep()
  }

  return (
    <div className={classes.container}>
      <LoaderBackdrop loading={load} />
      <div className={classes.rootDiv}>
        {selectedCars?.map(car => (
          <CarSelectionCard
            car={car}
            onClick={() => handleCarClick(car)}
            isNotDemonstrated={
              userRole !== MANAGER_AUTO_DAMU &&
              !getDemonstrationResults(car.vin) &&
              keysList?.find(k => k.vin === car.vin)?.status === ON_YOU
            }
          />
        ))}
      </div>
      <div className={classes.buttonBar}>
        {userRole === MANAGER_AUTO_DAMU ? (
          <div />
        ) : (
          <Button
            variant={'contained'}
            onClick={handleOpenKeys}
            disabled={load}
          >
            Получить ключи
          </Button>
        )}
        <Button variant={'contained'} color={'primary'} onClick={checkPrevSave}>
          Продолжить
        </Button>
      </div>
      {activeCar?.id && (
        <Modal
          fullWidth
          maxWidth={'md'}
          open={activeCar}
          onClose={() => handleCarClick(null)}
        >
          <CarData
            vin={activeCar.vin}
            keyCode={keysList?.find(k => k.vin === activeCar.vin)?.status}
            demonstrationResults={getDemonstrationResults(activeCar.vin)}
            onClose={() => handleCarClick(null)}
          />
          <DialogActions>
            {keysList?.find(k => k.vin === activeCar.vin)?.status ===
              ON_YOU && (
              <Button
                fullWidth
                size={'medium'}
                variant={'contained'}
                onClick={() => setIsInspectionModalOpen(!isInspectionModalOpen)}
              >
                Результат осмотра
              </Button>
            )}
            {userBranch !== activeCar.branch &&
              !getDemonstrationResults(activeCar.vin)?.isNotDemonstrated && (
                <Button
                  fullWidth
                  size={'medium'}
                  variant={'contained'}
                  onClick={() =>
                    sendInspectionResult(activeCar, {
                      resultPrice: '',
                      resultConfiguration: '',
                      resultExternal: '',
                      resultTechnical: '',
                      resultTestDriveExpress: null,
                      isNotDemonstrated: true
                    })
                  }
                >
                  Онлайн показ
                </Button>
              )}
          </DialogActions>
        </Modal>
      )}

      {openKeys && (
        <GetKeysModal
          open={openKeys}
          keysData={keysList}
          loading={load}
          onClose={handleOpenKeys}
          refreshKeys={getKeysStatus}
          acceptKey={acceptKeys}
        />
      )}
      {activeCar?.id && (
        <Modal
          open={isInspectionModalOpen}
          fullWidth
          onClose={() => setIsInspectionModalOpen(false)}
        >
          <CarInspection
            car={activeCar ? activeCar : null}
            onClose={() => setIsInspectionModalOpen(false)}
            isDisabled={false}
            sendInspectionResult={sendInspectionResult}
            initialData={{
              resultConfiguration: activeCar?.resultConfiguration,
              resultExternal: activeCar?.resultExternal,
              resultPrice: activeCar?.resultPrice,
              resultTechnical: activeCar?.resultTechnical,
              resultTestDrive: activeCar?.resultTestDrive,
              isNotDemonstrated: activeCar?.isNotDemonstrated,
              comment: activeCar?.comment
            }}
          />
        </Modal>
      )}
    </div>
  )
}

export default Demonstration
